export const DEFAULT_PARTY_ACCOUNTS_LIMIT = { key: 10, displayName: "10" };
export const DEFAULT_PARTY_ACCOUNTS_OFFSET = 1;
export const RAISE_SR_ATB_ACCOUNT_ISSUE = {
	ISSUE_CATEGORY: {
	  ATB_RELATED: "ATB Related Issue",
	},
	SUB_TYPE: {
	  ACCOUNT: "Account related issue on ATB",
	}
}

export const VIEW_MODE = {
	ACCORDION: "ACCORDION"
}